module.exports = __webpack_public_path__ + "static/media/piper-login-app-header.2a965bc2.png";